import { darken, rgba } from 'polished';
import React from 'react'
import styled from 'styled-components';
import { colors, neumorphism } from './constant';

const SearchBar = ({ value, setValue, className }) => {

    const onChange = e => {
        setValue?.(e.target.value);
    }

    return <Input className={className} type="text" onChange={onChange} placeholder="Search..." defaultValue={value}></Input>
}

const Input = styled.input`
    display: block;
    width: 100%;
    padding: 8px 24px;
    box-sizing: border-box;

    background-color: #F0F0F0;
    border: 0;
    border-radius: 100em;
    outline: none;
    
    color: ${ colors.text };
    font-size: 16px;

    transition: background-color .2s;
    -webkit-appearance: none;

    ${ neumorphism.concave };

    &:focus {
        background-color: ${ darken(0.03, '#F0F0F0') };
        border: 0;
    }

    &::placeholder {
        color: ${ rgba(colors.text, 0.3) };
    }
`

export default SearchBar
